import { FC, useRef } from 'react'
import './style.scss'
import { useClickAway } from '../../CustomHooks/useClickAway'

interface ActionsContextMenuProps {
    x: number,
    y: number,
    closeContextMenu: () => void,
    handleDelete: () => void,
    handleaddSlides: () => void,
    handleDuplicate: () => void,
    isFirstElement: boolean
}

const ActionsContextMenu: FC<ActionsContextMenuProps> = ({ x, y, closeContextMenu, handleDelete, handleaddSlides, handleDuplicate, isFirstElement }) => {

    const contextMenuRef = useRef<HTMLDivElement>(null)
    useClickAway(contextMenuRef, closeContextMenu)

    return (
        <div ref={contextMenuRef} className='ActionsContextMenu-container' style={{ top: `${y}px`, left: `${x > 35 ? 35 : x}px` }}>
            <ul>
                <li onClick={() => { handleaddSlides(); closeContextMenu() }}>
                    Add question
                </li>
                {!isFirstElement && <li onClick={() => { handleDelete(); closeContextMenu() }}>
                    Delete question
                </li>}
                <li onClick={() => { handleDuplicate(); closeContextMenu() }}>
                    Duplicate question
                </li>
            </ul>
        </div >
    )
}

export default ActionsContextMenu